<template>
	<div>
		<el-form ref="form" :model="form" :rules="rules" size="small" label-position="right" label-width="150px">
			<el-row :gutter="20">
				<el-col :span="12">
					<el-form-item label="设备仪器及名称" prop="equipmentName">
						<el-input v-model.trim="form.equipmentName"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="型号" prop="model">
						<el-input v-model.trim="form.model"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="产地" prop="origin">
						<el-input v-model.trim="form.origin"></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="出厂日期" prop="manufactureDate">
						<el-date-picker
							v-model="form.manufactureDate"
							type="date"
							placeholder="选择日期"
							value-format="yyyy-MM-dd"
							format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="数量（台）" prop="quantity">
						<el-input v-model.trim="form.quantity" v-positiveInteger></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="功率（千瓦）" prop="powerKw">
						<el-input v-model.trim="form.powerKw" v-positiveNumber></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="原值（万元）" prop="originalValue">
						<el-input v-model.trim="form.originalValue" v-positiveNumber></el-input>
					</el-form-item>
				</el-col>
				<el-col :span="12">
					<el-form-item label="净值（万元）" prop="netValue">
						<el-input v-model.trim="form.netValue" v-positiveNumber></el-input>
					</el-form-item>
				</el-col>
			</el-row>
		</el-form>
	</div>
</template>

<script>
	/**
	 * 技术装备表单组件
	 */
	export default {
		name: 'TechnicalEquipment',
		components: {},
		data() {
			return {
				form: {
					// 主键
					id: '',
					// 设备名称
					equipmentName: '',
					// 型号
					model: '',
					// 产地
					origin: '',
					// 出厂日期
					manufactureDate: '',
					// 数量（台）
					quantity: '',
					// 功率（千瓦）
					powerKw: '',
					// 原值（万元）
					originalValue: '',
					// 净值（万元）
					netValue: ''
				},
				rules: {
					equipmentName: { required: true, message: '请输入', trigger: 'blur' },
					model: { required: true, message: '请输入', trigger: 'blur' },
					origin: { required: true, message: '请输入', trigger: 'blur' },
					manufactureDate: { required: true, message: '请输入', trigger: 'blur' },
					quantity: { required: true, message: '请输入', trigger: 'blur' },
					powerKw: { required: true, message: '请输入', trigger: 'blur' },
					originalValue: { required: true, message: '请输入', trigger: 'blur' },
					netValue: { required: true, message: '请输入', trigger: 'blur' }
				}
			}
		},
		created() {},
		mounted() {},
		methods: {
			// 表单保存操作（每个列表对应的表单组件必须添加此方法，且必须同名）
			handleSaveInfo() {
				return new Promise(resolve => {
					this.$refs.form.validate(valid => {
						if (valid) {
							resolve(this.form)
						}
					})
				})
			}
		}
	}
</script>

<style scoped></style>
